var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14ZM8.6675 7.325C7.3325 6.8825 6.6875 6.605 6.6875 5.9C6.6875 5.135 7.52 4.8575 8.045 4.8575C9.0275 4.8575 9.3875 5.6 9.47 5.8625L10.655 5.36C10.5425 5.03 10.04 3.9275 8.66 3.6875V2.75H7.3475V3.695C5.3975 4.115 5.3825 5.8325 5.3825 5.915C5.3825 7.6175 7.07 8.0975 7.895 8.3975C9.08 8.8175 9.605 9.2 9.605 9.92C9.605 10.7675 8.8175 11.1275 8.12 11.1275C6.755 11.1275 6.365 9.725 6.32 9.56L5.075 10.0625C5.5475 11.705 6.785 12.1475 7.34 12.2825V13.25H8.6525V12.32C9.0425 12.2525 10.9175 11.8775 10.9175 9.905C10.925 8.8625 10.4675 7.9475 8.6675 7.325Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/Paid.af5d0b3c.svg";
export { ForwardRef as ReactComponent };